import { render, staticRenderFns } from "./LabelsChange.vue?vue&type=template&id=741995d6&scoped=true&"
import script from "./LabelsChange.vue?vue&type=script&lang=js&"
export * from "./LabelsChange.vue?vue&type=script&lang=js&"
import style0 from "./LabelsChange.vue?vue&type=style&index=0&id=741995d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741995d6",
  null
  
)

export default component.exports